// prettier-ignore

import { Card, CardContent, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";

function NotFound() {
  const classes = useStyles();

  return (
       <div className={classes.root}>
        <div className={classes.appFrame}>
          <div className={classes.content}>
                 <Card className={classes.root}>
                  <CardContent>
                    <Typography variant="h5" component="h2">
                      Invalid Request/Route
                    </Typography>
                    <Typography
                      className={classes.pos}
                      color="textSecondary"
                    ></Typography>
                    <Typography variant="body2" component="p">
                      Must pass following claim and user information as part of
                      the request path!
                    </Typography>
                  </CardContent>
                </Card>
          </div>
        </div>
      </div>
  );
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    width: "100%",
    height: "100%",
    zIndex: 1,
    overflow: "hidden",
    backgroundColor: theme.custom.colors.primaryColor,
  },
  appFrame: {
    position: "relative",
    display: "flex",
    width: "100%",
    height: "100%",
  },
  content: {
    width: "100%",
    height: "calc(100% - 56px)",
    margin: "25px 2px",
    backgroundColor: theme.custom.colors.primaryColor,
    [theme.breakpoints.up("sm")]: {
      height: "calc(100% - 64px)",
      margin: "50px 300px",
    },
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  card: {
    width: "100%",
    height: "100%",
    zIndex: 1,
    overflow: "hidden",
    backgroundColor: theme.custom.colors.primaryColor,
  },
}));

export default NotFound;
